import './text-editor.scss';

import { type ComponentProps, Suspense, lazy, useEffect, useMemo } from 'react';

import { MainLoader } from '..';

const JoditEditor = lazy(() => import('jodit-react'));

interface IProps {
  defaultHeight?: number;
  basicHTML: string;
  onChange: (data: string) => void;
  onBlur?: (newValue: string) => void;
  isIframe?: boolean;
  removeButtons?: string[];
}

const TextEditor = ({
  defaultHeight = 600,
  basicHTML,
  onChange,
  onBlur,
  isIframe = true,
  removeButtons
}: IProps) => {
  // @ts-ignore
  const config: ComponentProps<typeof JoditEditor>['config'] = useMemo(
    () => ({
      readonly: false,
      tabIndex: 1,
      iframe: isIframe,
      height: defaultHeight,
      cleanHTML: {
        removeEmptyElements: false,
        replaceNBSP: false
      },
      preserveSpaces: true,
      editorCssText: 'white-space: pre-wrap;',
      uploader: {
        insertImageAsBase64URI: true
      },
      filebrowser: {
        ajax: {
          // Если undefined, то по дефолту отправляет запросу по /
          url: null // Отключает серверный файловый менеджер
        }
      },
      removeButtons
    }),
    []
  );

  useEffect(() => {
    const frame = document.querySelector<HTMLIFrameElement>(
      '#jodit-editor iframe'
    );
    if (!frame || !frame.contentWindow) return;
    const frameDocument = frame.contentWindow.document;

    const tables = frameDocument.querySelectorAll('table');
    tables.forEach((element: HTMLElement) => {
      element.style.marginLeft = '0';
    });
  }, []);

  return (
    <div id="jodit-editor">
      <Suspense fallback={<MainLoader fullWidth />}>
        <JoditEditor
          value={basicHTML}
          config={config}
          onChange={onChange}
          onBlur={onBlur}
        />
      </Suspense>
    </div>
  );
};

export default TextEditor;
